import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import DeveloperMultiSelect from './DeveloperMultiSelect';
import api from '../../api'
import axios from 'axios';
import {
  ArrowLeft,
  Star,
  Calendar,
  User,
  Tag,
  Clock,
  CheckCircle,
  XCircle,
  Edit,
  ChevronDown,
  ChevronRight,
  Info,
  AlertCircle,
  MessageSquare,
  History,
  User as UserIcon,
  Menu,
  X,
} from 'lucide-react';

// Composant de champ éditable compact
const CompactField = ({
  label,
  value,
  name,
  type = 'text',
  icon: Icon,
  onChange,
  options = [],
  multiple = false,
  disabled = false,
  error,
  className = '',
  required = false
}) => (
  <div className={`mb-3 ${className}`}>
    <label className="block text-xs font-medium text-gray-600 mb-1">
      <div className="flex items-center">
        {Icon && <Icon size={12} className="text-terrecuite mr-1" />}
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </div>
    </label>
    <div className="relative">
      {type === 'textarea' ? (
        <textarea
          name={name}
          value={value}
          onChange={onChange}
          disabled={disabled}
          rows={2}
          className={`w-full border border-gray-200 rounded px-3 py-2 text-gray-700 text-sm focus:outline-none focus:ring-1 focus:ring-terrecuite focus:border-terrecuite ${error ? 'border-red-300' : ''
            } ${disabled ? 'bg-gray-50' : 'bg-white'}`}
        />
      ) : type === 'select' ? (
        <select
          name={name}
          multiple={multiple}
          value={value}
          onChange={onChange}
          disabled={disabled}
          className={`w-full border border-gray-200 rounded px-3 py-2 text-gray-700 text-sm focus:outline-none focus:ring-1 focus:ring-terrecuite focus:border-terrecuite ${error ? 'border-red-300' : ''
            } ${disabled ? 'bg-gray-50' : 'bg-white'}`}
        >
          {!multiple && <option value="">--</option>}
          {options.map(opt => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      ) : (
        <input
          type={type}
          name={name}
          value={value}
          onChange={onChange}
          disabled={disabled}
          className={`w-full border border-gray-200 rounded px-3 py-2 text-gray-700 text-sm focus:outline-none focus:ring-1 focus:ring-terrecuite focus:border-terrecuite ${error ? 'border-red-300' : ''
            } ${disabled ? 'bg-gray-50' : 'bg-white'}`}
        />
      )}
      {!disabled && type !== 'select' && type !== 'textarea' && (
        <Edit className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400" size={12} />
      )}
      {error && (
        <p className="mt-1 text-xs text-red-500 flex items-center">
          <AlertCircle size={10} className="mr-1" /> {error}
        </p>
      )}
    </div>
  </div>
);

// Composant de section compact
const CompactSection = ({ title, children, icon: Icon }) => (
  <div className="mb-4">
    <h3 className="text-xs font-semibold text-gray-700 mb-2 flex items-center uppercase tracking-wider">
      {Icon && <Icon size={12} className="text-terrecuite mr-1" />}
      {title}
    </h3>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
      {children}
    </div>
  </div>
);

export default function TicketDetailCard() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
  const [showActivity, setShowActivity] = useState(!isMobile);

  const [loading, setLoading] = useState(true);
  const [etapes, setEtapes] = useState([]);
  const [devs, setDevs] = useState([]);
  const statuses = ['nouveau', 'en cours', 'terminé', 'rejeté'];
  const [form, setForm] = useState({
    nom: '',
    content: '',
    type: '',
    date_debut_technique: '',
    organisation_id: '',
    deadline_client: '',
    deadline_tech: '',
    priorite: '',
    etape_id: '',
    status: '',
    createur_id: '',
    testeur_id: '',
    affectee_par: '',
    developpeur_ids: [],
    nbr_jrs: '',
    nbr_jrs_valider: '',
    chef_de_projet_id: '',
    last_update: '',
    created_at: '',
    updated_at: '',
  });
  const [errors, setErrors] = useState('');
  const [backendErrors, setBackendErrors] = useState({});
  const [activities, setActivities] = useState([]);
  const [newMessage, setNewMessage] = useState('');
  const [module_ids, setModule_ids] = useState(null);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 1024;
      setIsMobile(mobile);
      if (!mobile) {
        setShowActivity(true);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // useEffect(() => {
  //   const fetchUser = async () => {
  //     try {
  //       const userResponse = await api.get('/me', { withCredentials: true });
  //       if (!userResponse.data.success) {
  //         console.error('Impossible de récupérer les informations utilisateur.');
  //         return;
  //       }

  //       const user = userResponse.data.user;
  //       setModule_ids(parseInt(user.module_id, 10));
  //     } catch (error) {
  //       console.error('Erreur lors de la récupération des informations utilisateur.');
  //     }
  //   };

  //   fetchUser();
  // }, []);

  const typeOptions = [
    { value: 'demande', label: 'Demande' },
    { value: 'bug', label: 'Bug' },
  ];

  const priorityOptions = [
    { value: '1', label: 'Faible' },
    { value: '2', label: 'Moyenne' },
    { value: '3', label: 'Haute' },
  ];

  // Simuler des données d'activité
  const mockActivities = [
    {
      id: 1,
      user: 'Admin System',
      action: 'modified',
      field: 'Statut',
      oldValue: 'Nouveau',
      newValue: 'En cours',
      timestamp: '2023-05-15T10:30:00Z'
    },
    {
      id: 2,
      user: 'Jean Dupont',
      action: 'modified',
      field: 'Priorité',
      oldValue: '2',
      newValue: '3',
      timestamp: '2023-05-15T11:45:00Z'
    },
  ];

useEffect(() => {
  setLoading(true);

  // 1️⃣ Charger le ticket + étapes
  Promise.all([
    api.get(`/tickets/${id}`),
    api.get('/parametrages/etapes'),
  ])
    .then(([tRes, eRes]) => {
      const t = tRes.data.ticket;

      // Remplir le formulaire
      setForm({
        nom: t.nom || '',
        content: t.content || '',
        type: t.type || '',
        date_debut_technique: t.date_debut_technique || '',
        organisation_id: t.organisation?.nomOrganisation || '',
        deadline_client: t.deadline_client || '',
        deadline_tech: t.deadline_tech || '',
        priorite: t.priorite?.toString() || '',
        etape_id: t.etape_id?.toString() || '',
        status: t.status || '',
        createur_id: t.createur?.nom || '',
        testeur_id: t.testeur?.nom || '',
        affectee_par: t.affectee_par?.nom || '',
        developpeur_ids: t.developpeurs?.map(d => d.utilisateur_id.toString()) || [],
        chef_de_projet_id: t.demande?.chef_de_projet_id?.toString() || '',
        nbr_jrs: t.demande?.nbr_jrs?.toString() || '',
        nbr_jrs_valider: t.demande?.nbr_jrs_valider?.toString() || '',
        last_update: t.last_update || '',
        created_at: t.created_at ? t.created_at.slice(0, 10) : '',
        updated_at: t.updated_at ? t.updated_at.slice(0, 10) : '',
      });

      setModule_ids(t.module.id);

      // Remplir les étapes
      setEtapes(
        eRes.data.etapes.map(e => ({ value: e.id.toString(), label: e.nom }))
      );

      // 2️⃣ Une fois le module_id connu → appel développeurs
      return api.get(`/utilisateurs/developpeurs/module/${t.module.id}`);
    })
    .then(dRes => {
      // Remplir les développeurs
      setDevs(
        dRes.data.developpeurs.map(d => ({
          value: d.utilisateur_id.toString(),
          label: `${d.prenom} ${d.nom}`,
        }))
      );

      // Simuler activités
      setActivities(mockActivities);
    })
    .catch((e) => setErrors(e.message))
    .finally(() => setLoading(false));

}, [id]);


  const handleChange = e => {
    const { name, value, selectedOptions } = e.target;
    setForm(prev => ({
      ...prev,
      [name]: selectedOptions ? Array.from(selectedOptions, o => o.value) : value,
    }));
  };

  const currentStep = form.etape_id;

  const handleSendMessage = () => {
    if (newMessage.trim() === '') return;

    const messageActivity = {
      id: activities.length + 1,
      user: 'Utilisateur Actuel',
      action: 'added',
      field: 'Commentaire',
      newValue: newMessage,
      timestamp: new Date().toISOString()
    };

    setActivities(prev => [messageActivity, ...prev]);
    setNewMessage('');
  };
  function getNextStatus(current) {
    const idx = statuses.indexOf(current);
    return statuses[(idx + 1) % statuses.length];
  }

  // 1) Fonction dédiée pour faire tourner le statut
  function updateStatus() {
    const next = getNextStatus(form.status);
    setForm(prev => ({ ...prev, status: next }));
  }

  // 2) handleSave n'affecte plus le statut, il envoie simplement tout form
  const handleSave = async () => {
    setBackendErrors({});
    // 1) On construit le payload en respectant vos clés API
    const payload = {};

    // — Champs "simples" (string / date)
    ['nom', 'content', 'type', 'date_debut_technique', 'deadline_client', 'deadline_tech', 'status']
      .forEach(key => {
        if (form[key]) payload[key] = form[key];
      });

    // — Clés numériques (IDs, priorités…)
    [
      ['priorite', 'priorite'],
      ['etape_id', 'etape_id'],          // votre validation attend etape_id
    ].forEach(([formKey, apiKey]) => {
      if (form[formKey] !== '') {
        payload[apiKey] = parseInt(form[formKey], 10);
      }
    });

    // — Tableau des développeurs
    if (form.developpeur_ids.length) {
      // le contrôleur attend "developpeur_ids" (selon votre validation)
      payload.developpeur_ids = form.developpeur_ids.map(v => parseInt(v, 10));
    }

    // — Si c'est une "demande", on ajoute les champs correspondants
    if (form.type === 'demande') {
      if (form.nbr_jrs) payload.nbr_jrs = parseInt(form.nbr_jrs, 10);
      if (form.nbr_jrs_valider) payload.nbr_jrs_valider = parseInt(form.nbr_jrs_valider, 10);
      if (form.chef_de_projet_id) payload.chef_de_projet_id = parseInt(form.chef_de_projet_id, 10);
    }

    try {
      await api.post(`/tickets/${id}`, payload, {
        withCredentials: true, // إذا تستخدم cookie JWT
      });
      alert('Mis à jour avec succès');
      navigate(-1);
    } catch (err) {
      if (err.response?.status === 422) {
        // On affiche les erreurs de validation renvoyées par Laravel
        setBackendErrors(err.response.data.errors || {});
      } else {
        setErrors('Erreur interne du serveur');
      }
    }
  };

  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-pulse flex items-center">
          <div className="h-6 w-6 bg-terrecuite rounded-full mr-2"></div>
          <span className="text-sm">Chargement en cours...</span>
        </div>
      </div>
    );
  if (errors)
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="bg-red-100 border border-red-300 text-red-700 px-3 py-2 rounded flex items-center text-sm">
          <AlertCircle className="mr-2" size={14} />
          <p>{errors}</p>
        </div>
      </div>
    );

  const isRejected = form.status === 'rejeté';
  const statusClass = isRejected
    ? 'bg-red-100 text-red-600'
    : 'bg-green-100 text-green-600';

  return (
    <div className="min-h-screen bg-gray-50 p-2 md:p-3">
      <div className="max-w-7xl mx-auto">
        {/* Header compact */}
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center">
            <button
              onClick={() => navigate(-1)}
              className="flex items-center text-terrecuite hover:text-terrecuite-dark mr-3 text-sm p-2 md:p-0"
            >
              <ArrowLeft size={16} className="mr-1" />
              <span className="hidden md:inline">Retour</span>
            </button>
            <h1 className="text-lg font-bold text-gray-800">Ticket #{id}</h1>
            <span
              onClick={updateStatus}
              className={`ml-2 px-2 py-1 text-xs rounded-full font-medium cursor-pointer ${statusClass}`}
            >
              {form.status}
            </span>
          </div>
          <div className="flex space-x-2">
            {isMobile && (
              <button
                onClick={() => setShowActivity(!showActivity)}
                className="p-2 rounded text-terrecuite bg-white border border-gray-200"
              >
                {showActivity ? <X size={16} /> : <Menu size={16} />}
              </button>
            )}
            <button
              onClick={() => navigate(-1)}
              className="px-3 py-2 md:py-1.5 border border-gray-200 rounded text-xs font-medium text-gray-700 bg-white hover:bg-gray-50"
            >
              Annuler
            </button>
            <button
              onClick={handleSave}
              className="px-3 py-2 md:py-1.5 rounded text-xs font-medium text-white bg-terrecuite hover:bg-terrecuite-dark"
            >
              Sauvegarder
            </button>
          </div>
        </div>
        
        {/* Barre d'étapes avec défilement horizontal sur mobile */}
        <div className="mb-4 overflow-x-auto">
          <ul className="flex items-center space-x-2 min-w-max">
            {etapes.map((step, idx) => {
              const isActive = step.value === currentStep;
              return (
                <li key={step.value} className="flex items-center">
                  {/* Pastille */}
                  <span
                    className={`
                    flex items-center justify-center w-6 h-6 rounded-full text-xs font-semibold
                    ${isActive
                        ? 'bg-terrecuite text-white'
                        : 'bg-gray-200 text-gray-500'}
                  `}
                  >
                    {idx + 1}
                  </span>
                  {/* Flèche sauf dernier */}
                  {idx < etapes.length - 1 && (
                    <ChevronRight className="mx-1 text-gray-400" size={12} />
                  )}
                  {/* Label */}
                  <span
                    className={`
                    text-xs font-medium 
                    ${isActive
                        ? 'text-terrecuite'
                        : 'text-gray-500'}
                  `}
                  >
                    {step.label}
                  </span>
                </li>
              );
            })}
          </ul>
        </div>
        
        {/* Contenu principal compact */}
        <div className="flex flex-col lg:flex-row gap-4">
          {/* Colonne gauche - Toutes les informations en version compacte */}
          <div className={`flex-1 bg-white rounded-lg shadow border border-gray-200 p-3 md:p-4 ${isMobile && showActivity ? 'hidden' : 'block'}`}>
            {/* Description */}
            <CompactSection title="Description" icon={MessageSquare}>
              <CompactField
                label="Sujet"
                name="nom"
                value={form.nom}
                onChange={handleChange}
                error={backendErrors.nom?.[0]}
                icon={Tag}
                required
                className="md:col-span-2"
              />
              <CompactField
                label="Description"
                name="content"
                type="textarea"
                value={form.content}
                onChange={handleChange}
                error={backendErrors.content?.[0]}
                className="md:col-span-2"
              />
            </CompactSection>

            {/* Détails */}
            <CompactSection title="Détails" icon={Info}>
              <CompactField
                label="Type"
                name="type"
                type="select"
                options={typeOptions}
                value={form.type}
                onChange={handleChange}
                error={backendErrors.type?.[0]}
                icon={Tag}
                required
              />
              <CompactField
                label="Priorité"
                name="priorite"
                type="select"
                options={priorityOptions}
                value={form.priorite}
                onChange={handleChange}
                error={backendErrors.priorite?.[0]}
                icon={Star}
              />
              <CompactField
                label="Étape"
                name="etape_id"
                type="select"
                options={etapes}
                value={form.etape_id}
                onChange={handleChange}
                error={backendErrors.etape_id?.[0]}
                icon={Clock}
              />
              {/* Remplace le select multiple basique par le composant pro */}
              <DeveloperMultiSelect
                options={devs}
                value={form.developpeur_ids}
                onChange={handleChange}
                error={backendErrors.developpeur_ids?.[0]}
              />
            </CompactSection>

            {/* Dates */}
            <CompactSection title="Dates" icon={Calendar}>
              {[
                { label: 'Création', name: 'created_at', disabled: true },
                { label: 'Modification', name: 'updated_at', disabled: true },
                { label: 'Début technique', name: 'date_debut_technique', disabled: false },
                { label: 'Deadline client', name: 'deadline_client', disabled: false },
                { label: 'Deadline tech', name: 'deadline_tech', disabled: false },
              ].map(field => (
                <div key={field.name} className="mb-3 relative">
                  <label className="block text-xs font-medium text-gray-600 mb-1">
                    {field.label}
                  </label>
                  <input
                    type="date"
                    name={field.name}
                    value={form[field.name]}
                    onChange={handleChange}
                    disabled={field.disabled}
                    className={`
                    w-full pl-3 pr-8 py-2
                    border ${backendErrors[field.name]?.[0] ? 'border-red-300' : 'border-gray-200'} 
                    rounded text-gray-700 text-sm
                    focus:outline-none focus:ring-1 focus:ring-terrecuite focus:border-terrecuite 
                    ${field.disabled ? 'bg-gray-50 cursor-not-allowed' : 'bg-white'}`}
                  />
                  {backendErrors[field.name]?.[0] && (
                    <p className="mt-1 text-xs text-red-500 flex items-center">
                      <AlertCircle size={10} className="mr-1" />
                      {backendErrors[field.name][0]}
                    </p>
                  )}
                </div>
              ))}
            </CompactSection>

            {/* Détails demande (conditionnel) */}
            {form.type === 'demande' && (
              <CompactSection title="Détails demande" icon={User}>
                <CompactField
                  label="Chef de projet"
                  name="chef_de_projet_id"
                  type="select"
                  options={devs}
                  value={form.chef_de_projet_id}
                  onChange={handleChange}
                  error={backendErrors.chef_de_projet_id?.[0]}
                  icon={User}
                  disabled
                />
                <CompactField
                  label="Jours estimés"
                  name="nbr_jrs"
                  type="number"
                  value={form.nbr_jrs}
                  onChange={handleChange}
                  error={backendErrors.nbr_jrs?.[0]}
                  icon={Clock}
                  disabled
                />
                <CompactField
                  label="Jours validés"
                  name="nbr_jrs_valider"
                  type="number"
                  value={form.nbr_jrs_valider}
                  onChange={handleChange}
                  error={backendErrors.nbr_jrs_valider?.[0]}
                  icon={Clock}
                  disabled
                />
              </CompactSection>
            )}

            {/* Contacts */}
            <CompactSection title="Contacts" icon={User}>
              <CompactField
                label="Organisation"
                name="organisation_id"
                type="text"
                value={form.organisation_id}
                icon={User}
                disabled={true}
              />
              <CompactField
                label="Créé par"
                name="createur_id"
                type="text"
                value={form.createur_id}
                icon={User}
                disabled={true}
              />
              <CompactField
                label="Testeur"
                name="testeur_id"
                type="text"
                value={form.testeur_id}
                icon={User}
                disabled={true}
              />
              <CompactField
                label="Affecté par"
                name="affectee_par"
                type="text"
                value={form.affectee_par}
                icon={User}
                disabled={true}
              />
            </CompactSection>
          </div>

          {/* Colonne droite - Activité compacte */}
          <div className={`lg:w-80 space-y-4 ${!showActivity ? 'hidden' : 'block'}`}>
            {/* Statut compact */}
            <div className="bg-white rounded-lg shadow border border-gray-200 p-3 md:p-4">
              <h3 className="text-xs font-semibold text-gray-700 mb-3 flex items-center uppercase tracking-wider">
                <Info size={12} className="text-terrecuite mr-1" />
                Statut
              </h3>
              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  {isRejected ? (
                    <XCircle size={14} className="text-red-500 mr-1" />
                  ) : (
                    <CheckCircle size={14} className="text-green-500 mr-1" />
                  )}
                  <span className="text-xs text-gray-700">
                    {isRejected ? 'Rejeté' : 'Actif'}
                  </span>
                </div>
                <span className={`px-2 py-1 text-xs rounded-full font-medium ${isRejected
                    ? 'bg-red-100 text-red-600'
                    : 'bg-green-100 text-green-600'
                  }`}>
                  {form.status}
                </span>
              </div>
            </div>

            {/* Activité compacte */}
            <div className="bg-white rounded-lg shadow border border-gray-200">
              <div className="p-3 md:p-4 border-b border-gray-200">
                <h3 className="text-xs font-semibold text-gray-700 flex items-center uppercase tracking-wider">
                  <History size={12} className="text-terrecuite mr-1" />
                  Activité
                </h3>
              </div>
              <div className="p-3 md:p-4 h-[calc(100vh-250px)] overflow-y-auto">
                {activities.length === 0 ? (
                  <div className="text-center text-gray-400 text-xs py-4">
                    Aucune activité
                  </div>
                ) : (
                  activities.map(activity => (
                    <div key={activity.id} className="flex mb-3 pb-3 border-b border-gray-100 last:border-0 last:mb-0 last:pb-0">
                      <div className="flex-shrink-0 mr-2">
                        <div className="bg-terrecuite bg-opacity-10 rounded-full w-6 h-6 flex items-center justify-center">
                          <UserIcon size={10} className="text-terrecuite" />
                        </div>
                      </div>
                      <div className="flex-1">
                        <div className="flex items-center mb-0.5">
                          <span className="font-medium text-xs text-gray-700 mr-1">{activity.user}</span>
                          <span className="text-2xs text-gray-400">{new Date(activity.timestamp).toLocaleTimeString()}</span>
                        </div>
                        <div className="text-2xs text-gray-600">
                          {activity.action === 'modified' ? (
                            <>
                              Modifié <span className="font-medium text-terrecuite">{activity.field}</span>
                            </>
                          ) : (
                            <>
                              Ajouté <span className="font-medium text-terrecuite">{activity.field}</span>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  ))
                )}
              </div>
              <div className="p-3 md:p-4 border-t border-gray-200">
                <div className="flex flex-col space-y-2">
                  <textarea
                    value={newMessage}
                    onChange={(e) => setNewMessage(e.target.value)}
                    placeholder="Ajouter un commentaire..."
                    rows={2}
                    className="w-full border border-gray-200 rounded px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-terrecuite focus:border-terrecuite"
                  />
                  <button
                    onClick={handleSendMessage}
                    className="self-end px-3 py-2 rounded text-xs font-medium text-white bg-terrecuite hover:bg-terrecuite-dark"
                  >
                    Envoyer
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}